import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import {
	BEmail,
	BForm,
	BPassword,
	BReset,
	BSubmit,
	BTextField,
} from 'mui-bueno';
import { CreateInvestigationRequest, LoadingProps } from '../../@types';
import { loginUser } from '../../axios/login';
import { loginSuccess } from '../../modules/login-reducer';
import axiosInstance from '../../axios/axios-instance';
import { useCardStyles, useFormStyles, useOtherStyles } from '../../App';
import About from '../About/About';
import Box from '@material-ui/core/Box';
import theme from '../../theme';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import { createInvestigation } from '../../axios/investigations';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { IsLoadingHOC } from '../../IsLoadingHOC';

const useStyles = makeStyles({
	root: {
		margin: '0 auto',
		padding: '30px',
		backgroundColor: theme.palette.secondary.dark,
		borderRadius: '10px'
	},
	inputField: {
		width: '100%',
	},
	loginButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		backgroundColor: theme.palette.secondary.main,
	},
	resetButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		backgroundColor: theme.palette.secondary.dark,
	},
});

export const CreateInvestigation = (props: LoadingProps) => {
	// const globalClasses = useOtherStyles();
	const formClasses = useFormStyles();
	const history = useHistory();
	const dispatcher = useDispatch();
	const classes = useStyles();
	const cardStyles = useCardStyles();

	const initialValues: CreateInvestigationRequest = {
		name: '',
		description: '',
	};

	const handleSubmit = (loginRequest: CreateInvestigationRequest) => {
		props.setLoading(true)
		createInvestigation(loginRequest)
			.then((res) => {
				props.setLoading(false)
				history.push(`/investigations/details/${res.data.id}`);
			})
			.catch((err: any) => {
				alert("An error occurred creating the investigation... please try again later or contact a site admin");
				props.setLoading(false)
				console.log('ERROR: ', err);
			});
	};

	return (
		<Box className={formClasses.formWrapper}>
			{/* <Card className={cardStyles.card}> */}
				<Typography variant='h4' className={formClasses.formTitle}>
					Create Investigation
				</Typography>
				<Typography
					variant='subtitle2'
					className={formClasses.formSubtitle}
				>
					Create an investigation
				</Typography>
				<Divider />
				<Formik
					initialValues={initialValues}
					onSubmit={handleSubmit}
					validateOnChange={false}
					validateOnBlur={false}
				>
					<BForm>
						<BTextField
							required
							name='name'
							placeholder='Name'
							full
							className={classes.inputField}
						/>
						<BTextField
							required
							name='description'
							placeholder='Description'
							full
							multiline
							rows={5}
							className={classes.inputField}
						/>
						
						<BSubmit className={classes.loginButton} name='submit'>
							Create Investigation
						</BSubmit>
					</BForm>
				</Formik>
			{/* </Card> */}
		</Box>
	);
};

export default IsLoadingHOC(CreateInvestigation);
